<template>
<div class="system-box">
    <div class="standard_remind">
        <p class="tips">相关制度说明：</p>
        <p>
            <i>•</i>
            <span>原则上，公司员工对外职位名称需与内部层级保持一致，例如内部是"产品经理"，则外部职位名称也是"XX经理"；</span>
        </p>
        <p>
            <i>•</i>
            <span>销售/BD/市场/公关员工，因此对外沟通的需要，外部职位名称可以比内部层级高一级，例如内部是销售经理，外部职位名称可以是高级销售经理；</span>
        </p>
        <p class="error">
            <i>•</i>
            <span>因为特殊业务需求，需要申请的对外职位名称超出上述规定时，请填写具体的原因（填写在下面的“申请原因”中），公司HR将征求公司领导的意见；</span>
        </p>
        <p>
            <i>•</i>
            <span>名片制作周期为收到确认邮件后的三个工作日，具体以通知为主，如有其它需求请提前在确认邮件中说明。</span>
        </p>
    </div>
</div>
</template>

<script>
export default {
    name: 'system'
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.system-box {
    min-height: 100vh;
    background-color: #fff;
}

.standard_remind {
    /* width: 9.2rem; */
    margin: 0 auto;
    padding-top: 20px;
    color: #333;
    font-size: 0.3733333rem;
    padding: 20px;

    .tips {
        font-size: 0.4266667rem;
        line-height: 0.96rem;
        height: 0.96rem;
        margin-bottom: 0.24rem;
    }

    p {
        line-height: 0.53333333rem;
        margin-bottom: 0.1066666667rem;
        display: flex;

        i {
            font-style: normal;
            margin-right: 5px;
        }

        &.error {
            color: #f44;
        }
    }
}
</style>
